import moment from 'moment';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { OnlyFansSubscriberTransactionProduct } from '../types/transactions';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface SubscriberTransactionsTotalsGroupByMonth {
    _id: {
        year: number;
        month: number;
    };
    products: {
        product: OnlyFansSubscriberTransactionProduct;
        total: number;
        average: number;
    }[];
    total: number;
    average: number;
}

const useSextforceMetricsAccountMonthlySales = (startDate: Date, endDate: Date, timezone: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch Monthly Sales Stats
    const fetchAccountMonthlySales = async (
        startDate: Date,
        endDate: Date,
        timezone: string,
    ): Promise<SubscriberTransactionsTotalsGroupByMonth[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/monthlysales?${new URLSearchParams({
            startDate: moment(startDate).tz(timezone, true).toISOString(),
            endDate: moment(endDate).tz(timezone, true).toISOString(),
            timezone: timezone,
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsMonthlySales', params.userId, startDate, endDate, timezone],
        () => fetchAccountMonthlySales(startDate, endDate, timezone),
        {
            refetchOnWindowFocus: false,
            staleTime: 60 * 1000 * 5,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useSextforceMetricsAccountMonthlySales;
